const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/layout/App/App.tsx';
import { useEffect } from 'react';
import * as Styles from './styles';
import * as DeviceActions from '@cistec/common_web/actions/deviceActions';
import { UncaughtErrorDialog } from '@cistec/common_web/components/UncaughtErrorDialog/UncaughtErrorDialog';
import { css } from '@emotion/css';
import { useDispatch } from 'react-redux';

/**
 * React properties
 */
interface IAppProps {
    children?: any;
    location?: Location;
}

const frameStyle = css`
    label: frame;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // FIXME backgroundcolor: theme.palette.background.default;
`;

/**
 * React Functional component
 */
export const App = (props: IAppProps) => {
    const dispatch = useDispatch<any>();

    const resizeHandler = () => {
        dispatch(DeviceActions.deviceScreenChanged(window) as any); // action uses thunk
    };

    const trackErrors = (
        _message: string | undefined,
        _filename?: string,
        _line?: number,
        _column?: number,
        _error?: Error
    ) => {
        // TODO: Implement LogError
    };

    useEffect(() => {
        // componentDidMount equivalent
        window.addEventListener('resize', resizeHandler, false);

        window.onerror = evt => trackErrors(evt.toString());
        (window as any).onunhandledrejection = (rejection: any) =>
            trackErrors(undefined, undefined, undefined, undefined, rejection.reason);

        // componentWillUnmount equivalent
        return () => {
            window.removeEventListener('resize', resizeHandler, false);
        };
    }, []);

    return (
        <div className={frameStyle}>
            <div className={Styles.contentAreaStyle}>{props.children}</div>
            <UncaughtErrorDialog />
        </div>
    );
};
